/**
 * 全站路由配置
 *
 * 建议:
 * 1. 代码中路由统一使用name属性跳转(不使用path属性)
 */
import Vue from "vue";
import Router from "vue-router";
import http from "@/utils/httpRequest";
import { isURL } from "@/utils/validate";
import { clearLoginInfo } from "@/utils";

Vue.use(Router);

// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require("./import-" + process.env.NODE_ENV);

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
  {
    path: "/404",
    component: _import("common/404"),
    name: "404",
    meta: { title: "404未找到" }
  },
  {
    path: "/login",
    component: _import("common/login"),
    name: "login",
    meta: { title: "登录" }
  },
  {
    path: "/merchant",
    component: _import("common/merchant"),
    name: "merchant",
    meta: { title: "商家入驻" }
  },
  {
    path: "/merchantClone",
    component: _import("common/merchantClone"),
    name: "merchantClone",
    meta: { title: "商家入驻" }
  }
];

// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
  path: "",
  component: _import("main"),
  name: "main",
  redirect: { name: "home" },
  meta: { title: "主入口整体布局" },
  children: [
    // 通过meta对象设置路由展示方式
    // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
    // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
    // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
    {
      path: "/home",
      component: _import("common/home"),
      name: "home",
      meta: { title: "首页" }
    },
    {
      path: "/storeorder",
      component: _import("order/storeorder"),
      name: "storeorder",
      meta: { title: "订单中心", isTab: true }
    },
    {
      path: "/storeincome",
      component: _import("finance/storeincome"),
      name: "storeincome",
      meta: { title: "店铺中心", isTab: true }
    },
    {
      path: "/storevirtual",
      component: _import("virtual/storevirtual"),
      name: "storevirtual",
      meta: { title: "虚拟商品", isTab: true }
    },
    {
      path: "/virtualAmend",
      component: _import("virtual/virtualAmend"),
      name: "virtualAmend",
      meta: { title: "兑换码列表", isTab: false }
    },
    {
      path: "/storecoupon",
      component: _import("coupon/storecoupon"),
      name: "storecoupon",
      meta: { title: "优惠券制作", isTab: true }
    },
    {
      path: "/storeissue",
      component: _import("coupon/storeissue"),
      name: "storeissue",
      meta: { title: "已发布优惠券", isTab: true }
    },
    {
      path: "/storeuser",
      component: _import("coupon/storeuser"),
      name: "storeuser",
      meta: { title: "优惠券领取记录", isTab: true }
    },
    {
      path: "/storeclass",
      component: _import("selfShop/storeclass"),
      name: "storeclass",
      meta: { title: "商品分类", isTab: true }
    },
    {
      path: "/storecation",
      component: _import("selfShop/specification"),
      name: "storecation",
      meta: { title: "商品规格", isTab: true }
    },
    {
      path: "/storeshop",
      component: _import("selfShop/storeshop"),
      name: "storeshop",
      meta: { title: "商品列表", isTab: true }
    },
    {
      path: "/shopAmend",
      component: _import("selfShop/shopAmend"),
      name: "shopAmend",
      meta: { title: "修改商品", isTab: false }
    },
    {
      path: "/discuss",
      component: _import("selfShop/discuss"),
      name: "discuss",
      meta: { title: "商品评论", isTab: false }
    },
    {
      path: "/orderDetails",
      component: _import("selfShop/orderDetails"),
      name: "orderDetails",
      meta: { title: "订单详情", isTab: false }
    },
    {
      path: "/storemessage",
      component: _import("shopAdmin/storemessage"),
      name: "storemessage",
      meta: { title: "店铺信息", isTab: true }
    },
    {
      path: "/storeplaint",
      component: _import("finance/storeplaint"),
      name: "storeplaint",
      meta: { title: "投诉管理", isTab: true }
    },
    {
      path: "/alipay",
      component: _import("selfShop/alipay"),
      name: "alipay",
      meta: { title: "充值", isTab: true }
    },
    {
      path: "/vueMchat",
      component: _import("vueMchat/vueMchat"),
      name: "vueMchat",
      meta: { title: "聊天室", isTab: true }
    },
    {
      path: "/vueMchatsum",
      component: _import("vueMchat/vueMchatsum"),
      name: "vueMchatsum",
      meta: { title: "总后台聊天", isTab: true }
    },
    {
      path: "/comment1",
      component: _import("comment/comment"),
      name: "comment1",
      meta: { title: "评价管理", isTab: true }
    },
    {
      path: "/storeshop1",
      component: _import("selfShop/storeshop1"),
      name: "storeshop1",
      meta: { title: "商品列表", isTab: false }
    },
    {
      path: "/shopPublishXs",
      component: _import("selfShop/shopPublish1"),
      name: "shopPublishXs",
      meta: { title: "发布商品", isTab: false }
    },
    {
      path: "/agentManage",
      component: _import("agent/agentManage"),
      name: "agentManage",
      meta: { title: "客服管理", isTab: false }
    }
  ],
  beforeEnter(to, from, next) {
    let token = Vue.cookie.get("token");
    if (!token || !/\S/.test(token)) {
      clearLoginInfo();
      next({ name: "login" });
    }
    next();
  }
};

const router = new Router({
  mode: "history", //  hash
  scrollBehavior: () => ({ y: 0 }),
  isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
  routes: globalRoutes.concat(mainRoutes)
});

router.beforeEach((to, from, next) => {
  let userId = Vue.cookie.get("userId");
  // 添加动态(菜单)路由
  // 1. 已经添加 or 全局路由, 直接访问
  // 2. 获取菜单列表, 添加并保存本地存储

  if (
    userId == "" ||
    router.options.isAddDynamicMenuRoutes ||
    fnCurrentRouteType(to, globalRoutes) === "global"
  ) {
    next();
  } else {
    http({
      url: http.adornUrl2(`/sys/menu/nav?userId=${userId}`),
      method: "get",
      params: http.adornParams()
    })
      .then(({ data }) => {
        if (data && data.status === 0) {
          fnAddDynamicMenuRoutes(data.data.menuList);
          router.options.isAddDynamicMenuRoutes = true;
          sessionStorage.setItem(
            "menuList",
            JSON.stringify(data.data.menuList || "[]")
          );
          sessionStorage.setItem(
            "permissions",
            JSON.stringify(data.data.permissions || "[]")
          );
          next({ ...to, replace: true });
        } else {
          sessionStorage.setItem("menuList", "[]");
          sessionStorage.setItem("permissions", "[]");
          next();
        }
      })
      .catch(e => {
        console.log(
          `%c${e} 请求菜单列表和权限失败，跳转至登录页！！`,
          "color:blue"
        );
        router.push({ name: "login" });
      });
  }
});

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType(route, globalRoutes = []) {
  var temp = [];
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return "global";
    } else if (
      globalRoutes[i].children &&
      globalRoutes[i].children.length >= 1
    ) {
      temp = temp.concat(globalRoutes[i].children);
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : "main";
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = [], routes = []) {
  var temp = [];
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].list && menuList[i].list.length >= 1) {
      temp = temp.concat(menuList[i].list);
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//, "");
      var route = {
        path: menuList[i].url.replace("/", "-"),
        component: null,
        name: menuList[i].url.replace("/", "-"),
        meta: {
          menuId: menuList[i].menuId,
          title: menuList[i].name,
          isDynamic: true,
          isTab: true,
          iframeUrl: ""
        }
      };
      // url以http[s]://开头, 通过iframe展示
      if (isURL(menuList[i].url)) {
        route["path"] = `i-${menuList[i].menuId}`;
        route["name"] = `i-${menuList[i].menuId}`;
        route["meta"]["iframeUrl"] = menuList[i].url;
      } else {
        try {
          route["component"] = _import(`modules/${menuList[i].url}`) || null;
        } catch (e) {}
      }
      routes.push(route);
    }
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes);
  } else {
    mainRoutes.name = "main-dynamic";
    mainRoutes.children = routes;
    router.addRoutes([mainRoutes, { path: "*", redirect: { name: "404" } }]);
    sessionStorage.setItem(
      "dynamicMenuRoutes",
      JSON.stringify(mainRoutes.children || "[]")
    );
    console.log("\n");
    console.log(
      "%c!<-------------------- 动态(菜单)路由 s -------------------->",
      "color:blue"
    );
    console.log(mainRoutes.children);
    console.log(
      "%c!<-------------------- 动态(菜单)路由 e -------------------->",
      "color:blue"
    );
  }
}

export default router;
